import { GridSortModel } from "@mui/x-data-grid";
import { useMemo } from "react";
import { TablePage } from "src/shared/components/Table";
import { IFilterModel } from "src/shared/components/Table/model/types";
import {
  Transaction,
  TransactionDrawerSummary,
} from "../../../entities/transactions/model/types";
import { getColumns } from "./columns";

type Props = {
  rows: Transaction[];
  loading: boolean;
  rowCount?: number;
  paginationModel: { page: number; pageSize: number };
  pageSizeOptions: number[];
  onPaginationModelChange: (model: { page: number; pageSize: number }) => void;
  sortModel: GridSortModel;
  onSortModelChange: (model: GridSortModel) => void;
  filters: IFilterModel["filters"];
  onFilter: IFilterModel["onFilter"];
  onResetFilter: (params: string[]) => void;
  onOpenDrawer: (summary: TransactionDrawerSummary) => void;
  search: string;
  onSearch: (v: string) => void;
};

export function TransactionsTable(props: Props) {
  const {
    rows,
    loading,
    rowCount,
    paginationModel,
    pageSizeOptions,
    onPaginationModelChange,
    sortModel,
    onSortModelChange,
    filters,
    onFilter,
    onResetFilter,
    onOpenDrawer,
    search,
    onSearch,
  } = props;

  const columns = useMemo(() => getColumns({ onOpenDrawer }), [onOpenDrawer]);

  return (
    <TablePage
      columns={columns}
      rows={rows}
      loading={loading}
      title={null}
      tableSearchModel={{
        value: search,
        onSearch,
      }}
      tableFilterModel={{
        filters,
        onFilter,
        onReset: () =>
          onResetFilter([
            "period",
            "operation_types",
            "agencies",
            "clients",
            "accounts",
            "statuses",
            "dateFrom",
            "dateTo",
            "dateCalendarRange",
          ]),
      }}
      sortingMode="server"
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      paginationMode="server"
      rowCount={rowCount}
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      pageSizeOptions={pageSizeOptions}
      showCellVerticalBorder={false}
      showColumnVerticalBorder={false}
      sx={{
        flex: 1,
        width: "100%",
        "& .MuiDataGrid-root": {
          flex: 1,
          width: "100%",
          border: "none",
          "--DataGrid-rowBorderColor": "transparent",
          "--DataGrid-cellBorderColor": "transparent",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none !important",
          borderRight: "none !important",
          cursor: "default !important",
        },
        "& .MuiDataGrid-row": {
          borderBottom: "none !important",
          cursor: "default !important",
        },
        "& .MuiDataGrid-row:hover": {
          cursor: "default !important",
        },
        "& .MuiDataGrid-cell:hover": {
          cursor: "default !important",
        },
        "& .MuiDataGrid-columnHeaders": { borderBottom: "none !important" },
        "& .MuiDataGrid-columnHeader": { borderRight: "none !important" },
        "& .MuiDataGrid-cell--withRightBorder": {
          borderRight: "none !important",
        },
        "& .MuiDataGrid-columnHeader--withRightBorder": {
          borderRight: "none !important",
        },
        "& .MuiDataGrid-columnSeparator": { display: "none" },
      }}
    />
  );
}
